import { NUMBER } from "../../constants/app-constants";

const toFixedCustom = (value, precision = NUMBER.ONE) => {
    const power = Math.pow(NUMBER.TEN, precision || NUMBER.ONE);
    return (Math.round(value * power) / power);
};

export default toFixedCustom;
